import {
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILED,
  CLEAR_SEARCH,
} from "./types";

export const initialState = {
  searching: false,
  searchResults: null,
  query: "",
};

export const searchReducer = (state = initialState, action) => {
  switch (action?.type) {
    case SEARCH:
      return {
        ...state,
        searching: true,
      };
    case SEARCH_SUCCESS:
      return {
        ...state,
        searching: false,
        searchResults: action?.data?.results,
        query: action?.data?.query,
      };
    case SEARCH_FAILED:
      return {
        ...state,
        searching: false,
      };
    case CLEAR_SEARCH:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
